import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server05 = function Server05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 9c0 3.866-3.134 7-7 7m7-7c0-3.866-3.134-7-7-7m7 7H5m7 7c-3.866 0-7-3.134-7-7m7 7a10.71 10.71 0 0 0 2.8009-7A10.71 10.71 0 0 0 12 2m0 14a10.71 10.71 0 0 1-2.799-7A10.71 10.71 0 0 1 12 2m0 14v2M5 9c0-3.866 3.134-7 7-7m2 18c0 1.1046-.8954 2-2 2s-2-.8954-2-2m4 0c0-1.1046-.8954-2-2-2m2 2h7m-11 0c0-1.1046.8954-2 2-2m-2 2H3"
    })
  }));
};
export default Server05;